const Domain = [
    {
        name: "Code",
        desc: "One of the finest coding communities to be a part of in Manipal, IECSE's code domain provides the best resources to help hone coding, problem solving, and logical skills. Dive deep into Competitive Programming through our various workshops and coding contests held on our very own, Code Portal."
    },
    {
        name: "Machine Learning",
        desc: "At the ML domain, we bring together enthusiasts to build, integrate, and analyze compliant models, sourcing research papers to make our way through complex concepts, and letting the data speak for itself."
    },
    {
        name: "Dev",
        desc: "We provide a platform where blossoming developers mutually grow. From converting any design to a functioning frontend to developing optimised backend services, we do it all. We strive to bring some of Manipal's most ambitious ideas to life."
    },
    {
        name: "Studios",
        desc: "Our in-house studio provides the perfect environment for budding design enthusiasts to work and collaborate on projects ranging from poster graphics, social media content, video editing to UI/UX design. We are driven with the vision to hone our creative skills to make innovative designs."
    },
    {
        name: "Hashtag",
        desc: "Hashtag is IECSE's own technical column which is responsible for introducing the latest tech releases and innovations, opinionating over the various thought provoking topics and creating instructive tutorials on expanding the technical skillset of all its readers."
    },
];

export default Domain;